var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label blue"},[_vm._v(_vm._s(_vm.label))]),_c('br'),_c('date-picker',_vm._g(_vm._b({staticStyle:{"width":"100% !important"},attrs:{"value-type":"YYYY-MM-DD","format":"DD-MM-YYYY","type":"date","placeholder":_vm.label}},'date-picker',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }